<template>
  <el-dialog
    title="查看仓库信息"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <template>
      <div>
        <el-table
          :data="data"
          ref="table"
          highlight-current-row
        >
          <el-table-column
            label="仓库编号"
            prop="WarehouseId"
            width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="仓库名称"
            prop="WarehouseName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="配件名称"
            prop="MaterialName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="单位"
            prop="Unit"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="重量" prop="Weight" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="销售单价" prop="SalesPrice" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-pagination
          ref="breadCrumb"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="getTableData(1)"
          @current-change="getTableData()"
          :current-page.sync="pageIndex"
          :page-size.sync="pageSize"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </template>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
export default {
  props: ["item"],
  components: {},
  data() {
    return {
        visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      WarehouseId: "",
      PartsId: "",
      selectdata: [],
      EntyId: [],
      data: [],
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        this.visible = true;
        this.$get("MaterialSalesRecords/GetMaterialEntryRecordsList", {
          SalesId: v.SalesId,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize,
        }).then((r) => {
          let list = r.Result;
          let pageTotal = r.Rows;
          if (list.length > 0) {
            let row = list[0];
            this.$refs.table.setCurrentRow(row);
          }
          this.data = list;
          this.pageTotal = pageTotal;
        });
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>